import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
`

export const Title = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: ${myPalette.midnightBlue.main};
  margin-bottom: 8px;
`

export const Description = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: ${myPalette.midnightBlue.main};
  margin-bottom: 33px;
`

export const Img = styled.img`
  max-width: 328px;
  margin-bottom: 34px;
`

export const ButtonWrapper = styled.div`
  width: 100%;
`
